// extracted by mini-css-extract-plugin
export var productImage = "_zw-0";